<template>
<div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3">{{title}}</div>
      <div class="setting-addel mr-l15">
        <el-button size="mini" @click="addUserDefineOid"><i class="fas fa-plus"></i></el-button>
        <el-button size="mini" :disabled="!enableEditButton" @click="deleteUserDefineList"><i class="fas fa-minus"></i></el-button>
      </div>
    </div>
    <div>
      <el-button size="small" type="primary" :disabled="!enableEditButton" @click="groupSaveClick">그룹 저장</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper v-loading="loading" :data="tableData" :columns="userDefineColumns" ref="userDefineTable" row-class-name="c-dblclick" :column-default="columnDefault" @condition-change="onTableConditionChange" :total="total" remote pagination :show-custom-header="true"
    :show-search-tool="showSearchTool" style="width:100%;" @selection-change="userDefineChangeSelection" @row-dblclick="editUserDefineOid">
  </el-table-wrapper>
  <w-user-define-popup ref="userDefinePopup" @reload-data="loadData" />
  <w-group-save-user-define-popup ref="groupSaveUserDefinePopup" @reload-data="loadData" :selectGroupList="selectGroupList"></w-group-save-user-define-popup>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import clone from 'lodash/clone';
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import WUserDefinePopup from '@/views/settings/netdevice/OidSettings/UserDefineOidSettings/popup/UserDefinePopup';
import WGroupSaveUserDefinePopup from '@/views/settings/netdevice/OidSettings/UserDefineOidSettings/popup/GroupSaveUserDefinePopup';

export default {
  name: 'WUserDefineOidView',
  components: {
    WUserDefinePopup,
    WGroupSaveUserDefinePopup,
  },
  props: {
    selectPhysicalNode: Object,
  },
  data() {
    return {
      columnDefault,
      loading: false,
      showSearchTool: false,
      editRow: {},
      selectGroupList: [],
      selection: [],
      total: null,
      tableData: null,
      userDefineColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'rscName',
          label: '자원명',
          remoteProp: 'r.rsc_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'rscSnmpOid',
          remoteProp: 'mkor.mapping_value',
          width: 600,
          label: 'OID',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'rscUnit',
          width: 130,
          label: '자원 단위',
          remoteProp: 'r.rsc_unit',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'rscDatatypeName',
          width: 130,
          label: '결과 형태',
          remoteProp: 'rd.rsc_datatype_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  computed: {
    /**
     * 사용자정의 OID 타이틀
     * @author Ju
     * @return {[type]} [description]
     */
    title() {
      const title = '사용자 정의 OID 목록';
      return isNil(this.selectPhysicalNode) ? title : `[${this.selectPhysicalNode.label}] ${title}`;
    },
    /**
     * 편집 버튼 사용 가능 여부 (삭제, 저장)
     * @author Ju
     * @return {[type]} [description]
     */
    enableEditButton() {
      return this.selection.length > 0;
    },
  },
  watch: {
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.selectPhysicalNode)) {
          if (this.$refs.userDefineTable) {
            this.loadData();
          } else {
            this.$nextTick(() => {
              this.loadData();
            });
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * [loadData 사용자 정의 OID 목록을 불러온다.]
     * @author yelim
     */
    loadData() {
      const objId = this.selectPhysicalNode.obj.objId;
      const tableParams = this.$refs.userDefineTable.getParameter();
      const params = {
        objId,
        ...tableParams,
      };
      this.loading = true;
      NetdeviceSettingAPI.getUserDefineOidList(params)
        .then((result) => {
          if (result.data.success) {
            this.tableData = result.data.data;
            this.total = result.data.total;
          } else {
            this.failToLoad();
          }
        })
        .catch(() => {
          this.failToLoad();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '사용자 정의 OID', false));
    },
    /**
     * [addUserDefineOid 사용자 정의 OID 항목을 추가하는 팝업을 띄운다.]
     * @author yelim
     */
    addUserDefineOid() {
      this.$refs.userDefinePopup.open(this.selectPhysicalNode);
    },
    /**
     * [editUserDefineOid 사용자 정의 OID를 수정하는 팝업을 띄운다.]
     * @author yelim
     */
    editUserDefineOid(row) {
      this.$refs.userDefinePopup.open(this.selectPhysicalNode, clone(row));
    },
    userDefineChangeSelection(selectVal) {
      this.selection = selectVal;
    },
    /**
     * [deleteUserDefineList 사용자 정의 OID 항목을 삭제한다.
     *     Rsc 테이블과 mappingKeyObjRsc 테이블 cascade]
     * @author yelim
     */
    deleteUserDefineList() {
      const me = this;
      const deleteList = [];
      me.selection.forEach((item) => {
        deleteList.push({
          managetypeId: 'NMS',
          rsctypeId: 'USERDEFINE',
          rscId: item.rscId,
        });
      });
      const target = '사옹자정의 OID';
      const action = msgUtil.action.DELETE;

      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        NetdeviceSettingAPI.deleteUserDefineOidList(deleteList)
          .then((result) => {
            if (result.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              me.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
    },
    /**
     * [groupSaveClick 사용자 정의 OID 항목을 그룹저장하는 팝업을 띄운다.]
     * @author yelim
     */
    groupSaveClick() {
      this.selectGroupList = this.selection;
      this.$refs.groupSaveUserDefinePopup.open();
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onTableConditionChange() {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/UserDefineOidSettings/component/UserDefineOidView.vue